/* @flow weak */
import { Record } from '../transit';

const State = Record({
  appName: 'Trisbee Pokladna',
  appVersion: '0.1',
  firebase: '',
  sentryUrl: '',
}, 'config');

const configReducer = (state = new State()) => state;

export default configReducer;



// WEBPACK FOOTER //
// ./src/common/config/reducer.js